/**
 * Generate initials from first and last name.
 * Returns 'U' (Unknown) as fallback when names are not available.
 */
export const getInitials = (firstName?: string, lastName?: string): string => {
  if (!firstName && !lastName) return 'U';
  const first = firstName?.charAt(0) ?? '';
  const last = lastName?.charAt(0) ?? '';
  return `${first}${last}`.toUpperCase() || 'U';
};
